import { c as _c } from "react/compiler-runtime";
import { IcoInfo16 } from '@onefootprint/icons';
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
type DecryptionReasonProps = {
  detail: AuditEventDetail;
};
const DecryptionReason = t0 => {
  const $ = _c(14);
  const {
    detail
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.body.decryptionReason"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "decrypt_user_data") {
    return null;
  }
  const {
    reason
  } = detail.data;
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <IcoInfo16 />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t(_temp2);
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <div className="flex gap-1 items-center">{t3}<p className="text-label-2 text-primary fp-text">{t4}</p></div>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== reason) {
    t6 = <p className="text-body-2 text-primary fp-text max-md:wrap-anywhere">{reason}</p>;
    $[8] = reason;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t2 || $[11] !== t5 || $[12] !== t6) {
    t7 = <div aria-label={t2} className="w-full rounded border border-tertiary p-4 gap-2 flex flex-col mb-8">{t5}{t6}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default DecryptionReason;
function _temp($) {
  return $.ariaLabel;
}
function _temp2($_0) {
  return $_0.decryptionReason;
}